export const BRAND__FETCH_SITE__START = 'BRAND__FETCH_SITE__START';
export const BRAND__FETCH_SITE__SUCCESS = 'BRAND__FETCH_SITE__SUCCESS';
export const BRAND__FETCH_SITE__FAILURE = 'BRAND__FETCH_SITE__FAILURE';
export const BRAND__FETCH_FRAME__START = 'BRAND__FETCH_FRAME__START';
export const BRAND__FETCH_FRAME__SUCCESS = 'BRAND__FETCH_FRAME__SUCCESS';
export const BRAND__FETCH_FRAME__FAILURE = 'BRAND__FETCH_FRAME__FAILURE';
export const BRAND__FETCH_STATUS__START = 'BRAND__FETCH_STATUS__START';
export const BRAND__FETCH_STATUS__SUCCESS = 'BRAND__FETCH_STATUS__SUCCESS';
export const BRAND__FETCH_STATUS__FAILURE = 'BRAND__FETCH_STATUS__FAILURE';
export const BRAND__FETCH_DC__START = 'BRAND__FETCH_DC__START';
export const BRAND__FETCH_DC__SUCCESS = 'BRAND__FETCH_DC__SUCCESS';
export const BRAND__FETCH_DC__FAILURE = 'BRAND__FETCH_DC__FAILURE';
export const BRAND__SMS_SEND__START = 'BRAND__SMS_SEND__START';
export const BRAND__SMS_SEND__SUCCESS = 'BRAND__SMS_SEND__SUCCESS';
export const BRAND__SMS_SEND__FAILURE = 'BRAND__SMS_SEND__FAILURE';
export const BRAND__SMS_CHECK__START = 'BRAND__SMS_CHECK__START';
export const BRAND__SMS_CHECK__SUCCESS = 'BRAND__SMS_CHECK__SUCCESS';
export const BRAND__SMS_CHECK__FAILURE = 'BRAND__SMS_CHECK__FAILURE';
export const BRAND__ERROR_CHECK__START = 'BRAND__ERROR_CHECK__START';
export const BRAND__ERROR_CHECK__SUCCESS = 'BRAND__ERROR_CHECK__SUCCESS';
export const BRAND__ERROR_CHECK__FAILURE = 'BRAND__ERROR_CHECK__FAILURE';
